"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetail = void 0;
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const Yup = __importStar(require("yup"));
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const navigation_context_1 = require("../navigation/navigation-context");
const detail_types_1 = require("./detail-types");
const detail_toolbar_1 = require("./detail-toolbar");
const detail_container_1 = require("./detail-container");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../snackbar/snackbar-context");
const snackbar_types_1 = require("../snackbar/snackbar-types");
const empty_component_1 = require("../../utils/empty-component");
const evidence_context_1 = require("../evidence/evidence-context");
const empty_detail_container_1 = require("./empty-detail-container");
const evidence_defaults_context_1 = require("../evidence-defaults/evidence-defaults-context");
function useDetail(options, ref) {
    var _a, _b, _c, _d, _e;
    const formRef = react_1.useRef(null);
    const detailContainerRef = react_1.useRef(null);
    const defaults = react_1.useContext(evidence_defaults_context_1.EvidenceDefaultsContext);
    const props = {
        ToolbarComponent: (_a = defaults.ToolbarComponent) !== null && _a !== void 0 ? _a : detail_toolbar_1.DetailToolbar,
        ContainerComponent: (_b = defaults.ContainerComponent) !== null && _b !== void 0 ? _b : detail_container_1.DetailContainer,
        EmptyContainerComponent: (_c = defaults.EmptyContainerComponent) !== null && _c !== void 0 ? _c : empty_detail_container_1.EmptyDetailContainer,
        FieldsComponent: (_d = defaults.FieldsComponent) !== null && _d !== void 0 ? _d : empty_component_1.EmptyComponent,
        GeneralFieldsComponent: (_e = defaults.GeneralFieldsComponent) !== null && _e !== void 0 ? _e : empty_component_1.EmptyComponent,
        onPersisted: lodash_1.noop,
        initNewItem: defaultInitNewItem,
        showErrorPanel: false,
        resetScrollbarPosition: false,
        validationSchema: Yup.object(),
        ...options,
        toolbarProps: {
            ...options.toolbarProps,
        },
    };
    const intl = react_intl_1.useIntl();
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const confirmTitle = intl.formatMessage({
        id: 'EAS_DETAIL_LEAVE_DIALOG_TITLE',
        defaultMessage: 'Zanechání změn',
    });
    const confirmText = intl.formatMessage({
        id: 'EAS_DETAIL_LEAVE_DIALOG_TEXT',
        defaultMessage: 'Skutečně chcete opustit rozpracované změny?',
    });
    const { registerPrompt, unregisterPrompt } = react_1.useContext(navigation_context_1.NavigationContext);
    const { tableRef, detailRef } = react_1.useContext(evidence_context_1.EvidenceContext);
    const prompt = react_1.useMemo(() => ({
        title: confirmTitle,
        text: confirmText,
        clearCallback: () => {
            var _a, _b;
            (_a = detailRef.current) === null || _a === void 0 ? void 0 : _a.cancelEditing();
            (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.resetValidation();
        },
    }), [confirmTitle, confirmText, detailRef]);
    const [mode, setMode] = react_1.useState(detail_types_1.DetailMode.NONE);
    const refreshListeners = react_1.useRef([]);
    const setActive = event_callback_hook_1.useEventCallback(async (id) => {
        var _a;
        if (id !== null) {
            if (id !== ((_a = options.source.data) === null || _a === void 0 ? void 0 : _a.id)) {
                const data = await options.source.get(id);
                if (data !== undefined) {
                    setMode(detail_types_1.DetailMode.VIEW);
                }
            }
        }
        else {
            options.source.reset();
            setMode(detail_types_1.DetailMode.NONE);
        }
    });
    const callRefreshListeners = event_callback_hook_1.useEventCallback(() => {
        refreshListeners.current.forEach((l) => l());
    });
    const refresh = event_callback_hook_1.useEventCallback(() => {
        var _a;
        options.source.refresh();
        callRefreshListeners();
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
    });
    const refreshAll = event_callback_hook_1.useEventCallback(() => {
        var _a, _b, _c;
        if (mode === detail_types_1.DetailMode.VIEW) {
            options.source.refresh();
            callRefreshListeners();
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
            props.onPersisted((_c = (_b = options.source.data) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null);
        }
    });
    const startNew = event_callback_hook_1.useEventCallback((data) => {
        var _a;
        options.source.reset({ ...props.initNewItem(), ...data });
        setMode(detail_types_1.DetailMode.NEW);
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
        registerPrompt(prompt);
    });
    const startEditing = event_callback_hook_1.useEventCallback(() => {
        if (options.source.data !== null) {
            setMode(detail_types_1.DetailMode.EDIT);
            registerPrompt(prompt);
        }
    });
    const cancelEditing = event_callback_hook_1.useEventCallback(() => {
        var _a, _b, _c, _d, _e;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
        if (mode === detail_types_1.DetailMode.NEW) {
            const id = (_b = tableRef.current) === null || _b === void 0 ? void 0 : _b.activeRow;
            if (id) {
                setMode(detail_types_1.DetailMode.VIEW);
                (_c = detailRef.current) === null || _c === void 0 ? void 0 : _c.setActive(id);
            }
            else {
                setMode(detail_types_1.DetailMode.NONE);
                (_d = formRef.current) === null || _d === void 0 ? void 0 : _d.clearForm();
            }
            unregisterPrompt(prompt);
        }
        else if (mode === detail_types_1.DetailMode.EDIT) {
            setMode(detail_types_1.DetailMode.VIEW);
            unregisterPrompt(prompt);
            (_e = formRef.current) === null || _e === void 0 ? void 0 : _e.setFieldValues(options.source.data);
        }
    });
    const save = event_callback_hook_1.useEventCallback(async () => {
        if (formRef.current != null) {
            const errors = await validate(true);
            if (errors.length > 0) {
                return;
            }
            if (mode === detail_types_1.DetailMode.NEW) {
                const values = formRef.current.getFieldValues();
                const data = await options.source.create(values);
                unregisterPrompt(prompt);
                if (data !== undefined) {
                    react_dom_1.unstable_batchedUpdates(() => {
                        setActive(data.id);
                        setMode(detail_types_1.DetailMode.VIEW);
                        props.onPersisted(data.id);
                        callRefreshListeners();
                    });
                }
            }
            else if (mode === detail_types_1.DetailMode.EDIT) {
                const values = formRef.current.getFieldValues();
                const data = await options.source.update(values, options.source.data);
                unregisterPrompt(prompt);
                if (data !== undefined) {
                    setMode(detail_types_1.DetailMode.VIEW);
                    props.onPersisted(data.id);
                    callRefreshListeners();
                }
            }
        }
    });
    const del = event_callback_hook_1.useEventCallback(async () => {
        var _a, _b;
        if (mode === detail_types_1.DetailMode.VIEW && options.source.data !== null) {
            await options.source.del(options.source.data.id);
            options.source.reset();
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
            (_b = tableRef.current) === null || _b === void 0 ? void 0 : _b.resetSelection();
            setMode(detail_types_1.DetailMode.NONE);
            props.onPersisted(null);
        }
    });
    const validate = event_callback_hook_1.useEventCallback(async (hideSuccess = false) => {
        if (formRef.current != null) {
            const errors = await formRef.current.validateForm();
            const isValid = errors.length === 0;
            if (isValid) {
                if (!hideSuccess) {
                    const message = intl.formatMessage({
                        id: 'EAS_DETAIL_VALIDATION_MSG_SUCCESS',
                        defaultMessage: 'Formulář je v pořádku.',
                    });
                    showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
                }
            }
            else {
                const message = intl.formatMessage({
                    id: 'EAS_DETAIL_VALIDATION_MSG_ERROR',
                    defaultMessage: 'Formulář obsahuje chyby.',
                });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR, true);
            }
            return errors;
        }
        return [];
    });
    const addRefreshListener = event_callback_hook_1.useEventCallback((listener) => {
        refreshListeners.current = [...refreshListeners.current, listener];
    });
    const removeRefreshListener = event_callback_hook_1.useEventCallback((listener) => {
        refreshListeners.current = refreshListeners.current.filter((l) => l !== listener);
    });
    const context = react_1.useMemo(() => ({
        formRef: formRef.current,
        source: props.source,
        FieldsComponent: props.FieldsComponent,
        onPersisted: props.onPersisted,
        isExisting: mode === detail_types_1.DetailMode.VIEW || mode === detail_types_1.DetailMode.EDIT,
        mode,
        setMode,
        showErrorPanel: props.showErrorPanel,
        refresh,
        refreshAll,
        setActive,
        startNew,
        startEditing,
        cancelEditing,
        del,
        save,
        validate,
        addRefreshListener,
        removeRefreshListener,
        showButton: props.toolbarProps.showButton,
        disableButton: props.toolbarProps.disableButton,
    }), [
        formRef,
        props.source,
        props.FieldsComponent,
        props.onPersisted,
        props.showErrorPanel,
        mode,
        setMode,
        refresh,
        refreshAll,
        setActive,
        startNew,
        startEditing,
        cancelEditing,
        del,
        save,
        validate,
        addRefreshListener,
        removeRefreshListener,
        props.toolbarProps.showButton,
        props.toolbarProps.disableButton,
    ]);
    react_1.useEffect(() => {
        var _a, _b;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValues((_b = options.source.data) !== null && _b !== void 0 ? _b : {});
    }, [options.source.data]);
    react_1.useEffect(() => {
        var _a, _b;
        if (props.resetScrollbarPosition &&
            ((_a = detailContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) !== 0 &&
            options.source.loading) {
            (_b = detailContainerRef.current) === null || _b === void 0 ? void 0 : _b.scroll({ top: 0 });
        }
    }, [options.source.loading]);
    react_1.useImperativeHandle(ref, () => context, [context]);
    const editing = mode === detail_types_1.DetailMode.NEW || mode === detail_types_1.DetailMode.EDIT;
    return { props, context, formRef, detailContainerRef, editing };
}
exports.useDetail = useDetail;
function defaultInitNewItem() {
    return {
        id: uuid_1.v4(),
    };
}
//# sourceMappingURL=detail-hook.js.map